import styles from "./style/box.module.css";


const Box = ({text, children, vertical, dashboard}) => {
  return (
    <div className={`${styles.statisticsBoxItem} ${dashboard ? styles.statisticsBoxDash : ""}`}>
      <div className={`${styles.itemTitle} ${dashboard ? styles.itemTitleDash : ""}`}>{text}</div>
      {vertical ? (
        <div className={styles.itemsVertically}>
          {children}
        </div>
      ) : (
        <>{children}</>
      )}
    </div>
    
  );
};

export default Box;